import RowInfo from "./RowInfo";

export default RowInfo;